/* eslint-disable no-bitwise */
/* eslint-disable no-unused-vars */

const menu = () => {
  const menuSection = document.querySelector('.js-sections-menu');

  if (menuSection) {
    let lastId;
    const screenHeight = window.innerHeight;
    const menuItems = menuSection.querySelectorAll('a');
    const scrollItems = document.querySelectorAll('section');

    // Bind to scroll
    window.addEventListener('scroll', function() {
      // Get container scroll position
      let fromTop = screenHeight / 4 + 100 + window.pageYOffset;
      // Get id of current scroll item
      let cur = [];

      [...scrollItems].map(function(item) {
        //debugger;
        if (item.offsetTop < fromTop) {
          cur.push(item);
        }
      });

      // Get the id of the current element
      
      cur = cur[cur.length - 1];
      let id = cur ? cur.id : '';

      if (lastId !== id) {
        lastId = id;

        menuItems.forEach(function(elem, index) {
          elem.classList.remove('is-active');
          // Look at the child "a" tags and try to find the one for our section
          const filteredItems = [...menuItems].filter(
            elem => elem.getAttribute('href') === `#${id}`,
          );
          filteredItems[0].classList.add('is-active');
        });
      }
    });
  }
};

export default menu;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/eco-chisel/src/scripts/modules/menu.js